import { useState, useEffect } from "react";

import { apiRoot } from "../constants";

const useDish = (id) => {
  const [dish, setDish] = useState(null);
  const [dishEvents, setDishEvents] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`${apiRoot}/dishes/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setDish(json);
            setError(false);
            setLoading(false);
          });
        } else {
          setError(true);
          setDish();
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setDish();
        setLoading(false);
      });
  }, [id]);

  useEffect(() => {
    setLoading(true);
    fetch(`${apiRoot}/dishes/${id}/events`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setDishEvents(json);
            setError(false);
            setLoading(false);
          });
        } else {
          setError(true);
          setDishEvents([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setDishEvents([]);
        setLoading(false);
      });
  }, [id]);

  return {
    dish,
    dishEvents,
    error,
    loading,
  };
};

export default useDish;
